import {
  PRODUCT_REVIEW_DATA_LOADED,
  PRODUCT_REVIEW_DATA_CLEAR,
  PRODUCT_REVIEW_STATS_LOADED,
  PRODUCT_REVIEW_STATS_CLEAR,
  PRODUCT_REVIEW_META_LOADED,
  PRODUCT_REVIEW_META_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  productReviewData: null,
  productReviewStats: null,
  productReviewMeta: null,
};

const productReview = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_REVIEW_DATA_LOADED:
      return { ...state, productReviewData: action.payload.result };

    case PRODUCT_REVIEW_DATA_CLEAR:
      return { ...state, productReviewData: null };

    case PRODUCT_REVIEW_STATS_LOADED:
      return { ...state, productReviewStats: action.payload.result };

    case PRODUCT_REVIEW_STATS_CLEAR:
      return { ...state, productReviewStats: null };

    case PRODUCT_REVIEW_META_LOADED:
      return { ...state, productReviewMeta: action.payload.result };

    case PRODUCT_REVIEW_META_CLEAR:
      return { ...state, productReviewMeta: null };

    default:
      return state;
  }
};

export default productReview;
